import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { show as getPart } from "MODULES/parts/actions";
import { Map } from "immutable";
import { Paginator } from "@orange-marmalade/paginate-this";
import { loadRecord, withFilters } from "MODULES/shared/decorators";
import BackToPart from "MODULES/parts/components/shared/BackToPart";
import Table from "./Table";

const listId = "part/managedRepairOrderLineItems";

function Title() {
  return (
    <div>
      <h2>Managed Repair Order History</h2>
    </div>
  );
}

const TitleWithFilters = withFilters(Title);

export function ManagedRepairOrderLineItems({ part }) {
  const paginator = <Paginator listId={listId} />;

  return (
    <div>
      <BackToPart part={part} />
      <TitleWithFilters listId={listId} />
      <Table />
      {paginator}
    </div>
  );
}

ManagedRepairOrderLineItems.propTypes = {
  part: PropTypes.instanceOf(Map).isRequired
};

export default connect(state => ({
  part: state.partDetail.get("part")
}))(
  loadRecord({
    reducer: "partDetail",
    name: "part",
    action: getPart
  })(ManagedRepairOrderLineItems)
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/ManagedRepairOrderLineItems/ManagedRepairOrderLineItems.jsx